import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const CellWrapper = styled.div({
    flexDirection: "column",
    display: "flex",
    gap: Spacing.SM,
});

export const textCss = css`
    color: ${Colors.Black.V50};
`;
